<div id="myModal" class="modal-content">
  <div class="cookie-consent__banner">
      <h2>Cookies</h2>
      <p class="cookie-consent__inform">
          <span>This site uses cookies to offer you a better browsing experience.</span>
      </p>
      <button class="cookie-consent__button" (click)="changeAccept(true)">I ACCEPT COOKIES</button>
      <button class="cookie-consent__button" (click)="changeAccept(false)">I REFUSE COOKIES</button>
  </div>
</div>
